// @ts-nocheck
import { useEffect, useState } from 'react';
import useToast from 'hooks/useToast';
import axios from 'config/api';
import TextField, { Input } from '@material/react-text-field';
import Button from '@material/react-button';
import login_bg from 'assets/img/login_bg.png';
import logo from 'assets/img/login-logo.png';
import { getQueryParam } from 'utils/query-params';
import { useNavigate } from 'react-router-dom';
import { API_URL } from 'config/constants';
import { Box } from '@material-ui/core';
import {
  LockOutlinedIcon,
  VisibilityIcon,
  VisibilityOffIcon,
} from 'assets/icons';
import { common } from 'assets/colors/colors';
import { Logger } from 'utils/logger';

function ChangePasswordByUser() {
  const toast = useToast();
  const navigate = useNavigate();
  const [data, setData] = useState({
    tokenStatus: undefined,
    password: '',
    confirmPassword: '',
    showPassword: false,
    showConfirmPassword: false,
    errors: {},
    success: false,
    // onFailure: "",
    // username: "",
    // id: ""
    key: getQueryParam('key'),
  });

  const [loading, setLoading] = useState(true);
  const [res, setRes] = useState(undefined);
  const getTokenStatus = async () => {
    const { key } = data;
    if (!key) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const resp = await axios.get(
        `${API_URL}/user/update_password/?key=${key}`,
      );
      if (resp.status === 200) {
        setRes(resp.status);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      setRes(err.response.status);
      toast.error(err?.response?.data?.message || 'Server Error');
      Logger.error({
        message: 'Failed to get token status',
        data: { err },
      });
    }
  };

  useEffect(() => {
    getTokenStatus();
  }, []);

  const handleOnChange = (e) => {
    setData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };
  const mismatchPassword = 'Mismatch Password';
  const required = 'Required';
  const passwordLengthError =
    'Your password must be at least 8 characters long and contain at least 1 lowercase and 1 uppercase alphabetical character, 1 numeric character and 1 special character.';

  const validatePassword = () => {
    const { password, confirmPassword } = data;
    const errors = {};
    // const strongRegex = new RegExp(
    //   '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})',
    // );
    const strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+=-|:;?,./{}<>])(?=.{8,})',
    );
    const passwordTest = strongRegex.test(password);
    if (!password) errors.password = required;
    if (
      confirmPassword &&
      confirmPassword.length > 0 &&
      confirmPassword !== password
    ) {
      errors.password = mismatchPassword;
    }
    if (password && password.length > 0 && passwordTest === false) {
      errors.passwordType = passwordLengthError;
    }

    return errors;
  };

  const handlePasswordChecked = (check) => {
    setData((prevData) => ({
      ...prevData,
      [check]: !prevData[check],
    }));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validatePassword();
    setData((prevState) => ({ ...prevState, errors }));

    if (Object.keys(errors).length === 0) {
      const { password, key } = data;
      axios
        .put(`${API_URL}/user/update_password/?key=${key}`, {
          password,
        })
        .then((res) => {
          if (res.status === 200) {
            navigate('/login');
            toast.success('Password Changed Successfully');
          } else {
            toast.error(res.data.detail);
          }
        })
        .catch((e) => {
          toast.error(e.response.data.error);
        });
    } else {
      Logger.error({
        message: 'Something went wrong during password change',
      });
    }
  };
  return (
    <div
      className="authentication parallax-container"
      style={{ backgroundImage: `url(${login_bg})` }}
    >
      <div className="container">
        <div className="card auth_form">
          <div className="login-logo">
            <img className="logo" src={logo} alt="" />
          </div>
          {!loading && (
            <div className="body">
              <div className="login-header">
                {/* <h5>{username}</h5> */}
                {res === 200 ? (
                  <>
                    <p style={{ color: '#fff', fontSize: '1.2rem' }}>
                      <strong>Choose a New Password</strong>
                    </p>
                    <span
                      style={{
                        background: data.errors.passwordType
                          ? '#af3931'
                          : '#4CAF50',
                        borderRadius: 4,
                        fontWeight: 400,
                        fontSize: 14,
                        color: '#fff',
                        padding: 8,
                        display: 'block',
                        marginBottom: 20,
                        marginTop: 10,
                      }}
                    >
                      {data.errors.passwordType
                        ? data.errors.passwordType
                        : `Create a new password that
                      is atleast 8 characters long, combination of letters,
                      numbers and special symbols.`}
                    </span>
                  </>
                ) : (
                  <Box display="flex" alignItems="center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="80"
                      height="80"
                      fill="none"
                      viewBox="0 0 56 56"
                    >
                      <path
                        fill="#FBAD33"
                        d="M25.667 16.333h4.666V21h-4.666v-4.667zm0 9.334h4.666v14h-4.666v-14zm2.333-21C15.12 4.667 4.667 15.12 4.667 28 4.667 40.88 15.12 51.333 28 51.333c12.88 0 23.333-10.453 23.333-23.333C51.333 15.12 40.88 4.667 28 4.667zm0 42C17.71 46.667 9.333 38.29 9.333 28 9.333 17.71 17.71 9.333 28 9.333c10.29 0 18.667 8.377 18.667 18.667 0 10.29-8.377 18.667-18.667 18.667z"
                      ></path>
                    </svg>
                    <p style={{ color: '#fff' }}>
                      Password reset link is invalid or has expired.
                    </p>
                  </Box>
                )}
              </div>
              {res === 200 && (
                <form style={{ paddingTop: '1rem' }}>
                  <div className="form-group">
                    <TextField
                      outlined
                      label="Password*"
                      leadingIcon={
                        <LockOutlinedIcon
                          sx={{
                            color: `${common.icon} !important`,
                            fontSize: '18px',
                            marginBottom: '4px',
                          }}
                        />
                      }
                    >
                      <Input
                        id="password"
                        label="Password*"
                        name="password"
                        type={data.showPassword ? 'text' : 'password'}
                        value={data.password || ''}
                        onChange={handleOnChange}
                      />
                    </TextField>
                    <span
                      className="visible-icon"
                      role="button"
                      onClick={() => handlePasswordChecked('showPassword')}
                    >
                      {data.showPassword ? (
                        <VisibilityOffIcon
                          sx={{
                            color: common.icon,
                            fontSize: '18px',
                            cursor: 'pointer',
                          }}
                        />
                      ) : (
                        <VisibilityIcon
                          sx={{
                            color: common.icon,
                            fontSize: '18px',
                            cursor: 'pointer',
                          }}
                        />
                      )}
                    </span>
                  </div>

                  <div className="form-group">
                    <TextField
                      outlined
                      label="Confirm Password*"
                      leadingIcon={
                        <LockOutlinedIcon
                          sx={{
                            color: `${common.icon} !important`,
                            fontSize: '18px',
                            marginBottom: '4px',
                          }}
                        />
                      }
                    >
                      <Input
                        id="confirmPassword"
                        name="confirmPassword"
                        type={data.showConfirmPassword ? 'text' : 'password'}
                        value={data.confirmPassword || ''}
                        onChange={handleOnChange}
                      />
                    </TextField>
                    <span
                      className="visible-icon"
                      role="button"
                      onClick={() =>
                        handlePasswordChecked('showConfirmPassword')
                      }
                    >
                      {data.showConfirmPassword ? (
                        <VisibilityOffIcon
                          sx={{
                            color: common.icon,
                            fontSize: '18px',
                            cursor: 'pointer',
                          }}
                        />
                      ) : (
                        <VisibilityIcon
                          sx={{
                            color: common.icon,
                            fontSize: '18px',
                            cursor: 'pointer',
                          }}
                        />
                      )}
                    </span>

                    {data.errors.password && (
                      <span className="error">{data.errors.password}</span>
                    )}

                    {data.errors.confirmPassword && (
                      <span className="error">
                        {data.errors.confirmPassword}
                      </span>
                    )}
                  </div>
                  <div className="input-field col s12">
                    <Button
                      raised
                      type="submit"
                      onClick={onSubmit}
                      disabled={!data.password || !data.confirmPassword}
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ChangePasswordByUser;
